import React, { useState } from "react";
import { TreeSelect } from "antd";
import "./styles.scss"

const CustomTreeSelect = ({treeData, value, handleChange, width = '400px', className, isWhite = false, placeholder = "Selecione"}) => {

  const variante = isWhite ? "custom-select-antd" : "custom--tree-select-input-normal"

  return (
    <TreeSelect
      showSearch
      style={{ width: width }}
      className={`${variante} ${className}`}
      value={value ?? null}
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      placeholder={placeholder}
      treeNodeFilterProp="title"
      allowClear
      treeDefaultExpandAll
      treeData={treeData}
      onChange={handleChange}
    />
  );
};

export default CustomTreeSelect;
